var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "查询并开通观看权限",
        width: "490px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "studentCanVideo overflowOuto" }, [
        _c(
          "div",
          { staticClass: "searchTop" },
          [
            _c("selectTelEmail", {
              on: {
                onChange: function ($event) {
                  return _vm.getList()
                },
              },
              model: {
                value: _vm.search.userInfo,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "userInfo", $$v)
                },
                expression: "search.userInfo",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "m-l-20",
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.getList },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
        _vm.showTips
          ? _c("div", { staticClass: "errorTips" }, [
              _vm._v(" " + _vm._s(_vm.tips) + " "),
            ])
          : _vm._e(),
        _vm.userInfo.list.length > 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "listContent",
              },
              [
                _c("div", { staticClass: "listContentHeader" }, [
                  _c("label", [
                    _vm._v("学员昵称："),
                    _c("span", { staticClass: "username" }, [
                      _vm._v(_vm._s(_vm.userInfo.userName)),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "listContentBox" },
                  _vm._l(_vm.userInfo.list, function (item, index) {
                    return _c("div", { key: index, staticClass: "listView" }, [
                      _c("div", { staticClass: "listForm" }, [
                        _c("span", { staticClass: "formLabel" }, [
                          _vm._v("首次进入时间："),
                        ]),
                        _c("span", { staticClass: "formValue" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("renderTime")(
                                item.firstEntryTime,
                                "yyyy-MM-DD HH:mm:ss"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "listForm" }, [
                        _c("span", { staticClass: "formLabel" }, [
                          _vm._v("总听课时长："),
                        ]),
                        _c("span", { staticClass: "formValue" }, [
                          _vm._v(
                            _vm._s(_vm._f("filterTime")(item.listenClassTime))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "listForm" }, [
                        _c("span", { staticClass: "formLabel" }, [
                          _vm._v("直播间ID："),
                        ]),
                        _c("span", { staticClass: "formValue" }, [
                          _vm._v(_vm._s(item.liveRoomId)),
                        ]),
                      ]),
                      _c("div", { staticClass: "listForm" }, [
                        _c("span", { staticClass: "formLabel" }, [
                          _vm._v("直播间名称："),
                        ]),
                        _c("span", { staticClass: "formValue" }, [
                          _vm._v(_vm._s(item.liveRoomName)),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "ss-material-box-bottom",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "m-r-10" },
            [
              _vm.userInfo.studentId && _vm.liveModel === "AI_LIVE"
                ? _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.watchPermissConfig.canWatch,
                        callback: function ($$v) {
                          _vm.$set(_vm.watchPermissConfig, "canWatch", $$v)
                        },
                        expression: "watchPermissConfig.canWatch",
                      },
                    },
                    [_vm._v("允许该学员进入直播间")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    loading: _vm.watchPermissConfig.loading,
                    type: "primary",
                  },
                  on: { click: _vm.watchPermissConfigSuccess },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    loading: _vm.watchPermissConfig.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }